import { WorkFileIdentificationState } from './types'
import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'

export const getters: GetterTree<WorkFileIdentificationState, RootState> = {}
